import React from "react";
import { withStyles } from "@material-ui/core/styles";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";

import PropTypes from "prop-types";
import cx from "classnames";

import regularCardStyle from "assets/jss/material-dashboard-react/regularCardStyle";

function RegularCard(props) {
    const {
        classes,
        headerColor,
        plainCard,
        cardTitle,
        cardSubtitle,
        compact,
        content,
        footer,
    } = props;
    const cardPlainHeaderClasses = cx(classes.cardHeader, {
        [classes.compactTitle]: compact,
        [classes[`${headerColor}CardHeader`]]: headerColor,
        [classes.cardPlainHeader]: plainCard,
    });
    const plainCardClasses = cx(classes.card, {
        [classes.cardPlain]: plainCard,
    });
    return (
        <Card className={plainCardClasses}>
            <CardHeader
                classes={{
                    root: cardPlainHeaderClasses,
                    title: classes.cardTitle,
                    subheader: classes.cardSubtitle,
                }}
                title={cardTitle}
                subheader={cardSubtitle}
            />
            <CardContent className={cx(classes.cardContent, { [classes.compactContent]: compact })}>
                {content}
            </CardContent>
            {footer !== undefined ? (
                <CardActions className={classes.cardActions}>{footer}</CardActions>
            ) : null}
        </Card>
    );
}

RegularCard.defaultProps = {
    plainCard: true,
    headerColor: "white",
};

RegularCard.propTypes = {
    plainCard: PropTypes.bool,
    classes: PropTypes.object.isRequired,
    headerColor: PropTypes.oneOf(["orange", "green", "red", "blue", "purple", "white"]),
    cardTitle: PropTypes.node,
    cardSubtitle: PropTypes.node,
    compact: PropTypes.bool,
    content: PropTypes.node,
    footer: PropTypes.node,
};

export default withStyles(regularCardStyle)(RegularCard);
